// @flow
import React from "react";
import { type SearchFormResultDTO } from "data/types";
import Header from "components/Header";
import ToggleMode from "./ToggleMode";
import loc from "i18next";
import styles from "./SearchFormHeader.module.css";
import Button from "react-bootstrap/lib/Button";

type Props = {
    /** current SearchForm */
    searchForm: ?SearchFormResultDTO,
    /** callback when user clicks Cancel */
    onCancel: () => void,
    /** callback when user clicks Clear */
    onClear: () => void,
    /** used for evaluating if the clear button should be visible */
    clearEnabled: () => boolean,
};

/**
 * renders the SearchForm's panel header
 *
 * @param {Props} { searchForm, onCancel, onClear }
 */
const SearchFormHeader = ({ searchForm, onCancel, onClear, clearEnabled }: Props) => (
    <Header
        icon="search"
        title={
            (searchForm && searchForm.name) || loc.t("common:search.loading")
        }
        onCancel={onCancel}
        centerComponent={
            searchForm &&
            searchForm.attributes &&
            searchForm.attributes.length > 0 && <ToggleMode />
        }
        rightComponent={
            clearEnabled &&
            typeof clearEnabled === "function" &&
            clearEnabled() &&
            <Button
                onClick={onClear}
                className={styles.reset}
                aria-label={loc.t("search:form.clear")}
                bsStyle="link">
                {loc.t("search:form.clear")}
            </Button>}
    />
);

SearchFormHeader.displayName = "SearchFormHeader";
export default SearchFormHeader;
